import { authRequest } from './api/auth';
class UpGPTPortalDataServices {
    getThreadList() {
        return authRequest.get(`/upgpt_portal/thread/`);
    }
    createThread(data) {
        return authRequest.post(`/upgpt_portal/thread/`, data);
    }
    getQuestion(data) {
        return authRequest.get(`/upgpt_portal/thread/${data.thread_id}/`);
    }
    deleteThread(id) {
        return authRequest.delete(`/upgpt_portal/thread/${id}/`);
    }
    getReferencecontent(question_id, context_id) {
        return authRequest.get(`/upgpt_portal/question/${question_id}/reference/${context_id}`)
    }
    getreferenceQuestions(id) {
        return authRequest.get(`/upgpt_portal/question/${id}/`);
    }
    getRelatedQuestions(id) {
        return authRequest.get(`/upgpt_portal/question/${id}/related/`);
    }
    updateFeedBack(data) {
        return authRequest.put(`/upgpt/v2/eval/updatefeedback/${data.question_id}/`, data);
    }
    getCustomCompanyLogo() {
        return authRequest.get(`/upgpt_portal/getportalcompanylogo/`);
    }
    GetPortalHideAnsWithoutRef() {
        return authRequest.get(`/upgpt_portal/getportalhideanswithoutref/`);
    }
    stopStreaming(data) {
        return authRequest.post(`/upgpt_portal/stopstreaming/`, data);
    }
    // ==================== Agents ====================
    getAgentList(agent_style) {
        return authRequest.get(`/upgpt_agent/agent_list/?agent_style=${agent_style}`);
    }
    getAgentDetail(id) {
        return authRequest.get(`/upgpt_agent/agent_detail/${id}/`);
    }
    saveAgentDetail(id, data) {
        return authRequest.put(`/upgpt_agent/save_agent_default_setting/${id}/`, data);
    }
    getAgentUploadedFiles(data) {
        return authRequest.post(`/upgpt_agent/get_upload_files/`, data);
    }
    uploadAgentFiles(formData) {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        return authRequest.post(`/upgpt_agent/upload_files/`, formData, config);
    }
    createSimpleAgent(data) {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let formData = new FormData();
        formData.append("agent_name", data.agent_name);
        formData.append("instruction", data.instruction);
        formData.append("goal", data.goal);
        formData.append("icon_path", data.icon_path);
        formData.append("use_web_search", data.use_web_search);
        formData.append("use_knowledge_lib", data.use_knowledge_lib);
        formData.append("linked_knowledges", JSON.stringify(data.linked_knowledges));
        if (data.attach_document && data.attach_document.length > 0) {
            data.attach_document.forEach(file => {
                formData.append("attach_document", file)
            })
        }
        return authRequest.post(`/upgpt_agent/create_simple_agent/`, formData, config);
    }
    deleteAgent(id) {
        return authRequest.delete(`/upgpt_agent/delete_agent_detail/${id}/`)
    }
    getUserAgentList(agent_style, agent_definition_mode) {
        return authRequest.get(`/upgpt_agent/user_agent_list/?agent_style=${agent_style}&agent_definition_mode=${agent_definition_mode}`);
    }
    createUserSimpleAgent(data) {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let formData = new FormData();
        formData.append("agent_name", data.agent_name);
        formData.append("goal", data.goal);
        formData.append("instruction", data.instruction);
        formData.append("icon_path", data.icon_path);
        formData.append("use_web_search", data.use_web_search);
        formData.append("use_knowledge_lib", data.use_knowledge_lib);
        formData.append("linked_knowledges", JSON.stringify(data.linked_knowledges));
        formData.append("is_private", data.is_private);

        if (data.attach_document && data.attach_document.length > 0) {
            data.attach_document.forEach(file => {
                formData.append("attach_document", file)
            })
        }
        return authRequest.post(`/upgpt_agent/create_user_agent/`, formData, config);
    }
    getUserAgentDetail(id) {
        return authRequest.get(`/upgpt_agent/user_agent_detail/${id}/`);
    }
    getAgentDefinitionDetail(id) {
        return authRequest.get(`/upgpt_agent/agent_definition_detail/${id}/`);
    }
    saveUserAgentDetail(id, data) {
        return authRequest.put(`/upgpt_agent/save_user_agent_default_setting/${id}/`, data);
    }
    deleteUserAgent(id) {
        return authRequest.delete(`/upgpt_agent/delete_user_agent/${id}/`)
    }
    editDeleteFile(id, data) {
        return authRequest.post(`/upgpt_agent/edit_delete_file/${id}/`, data);
    }
    saveFiles(data) {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let formData = new FormData();
        formData.append("agent_id", data.agent_id);
        formData.append("is_private_agent", data.is_private_agent);
        if (data.attach_document && data.attach_document.length > 0) {
            data.attach_document.forEach(file => {
                formData.append("attach_document", file)
            })
        }
        return authRequest.post(`/upgpt_agent/save_agent_file/`, formData, config);
    }
    updateAgentStatus(data) {
        return authRequest.put(`/upgpt_agent/update_agent_status/`, data);
    }
    // ==================== Document Agent ====================
    getDocumentAgentTemplateList() {
        return authRequest.get(`/upgpt_agent/document_agent/template/`);
    }
    createDocumentAgent(data) {
        return authRequest.post(`/upgpt_agent/document_agent/`, data);
    }
    directCreateDocumentAgent(data = {}) {
        return authRequest.post(`/upgpt_agent/document_agent/`, { ...data, direct_create: true });
    }
    aiGenerateDocumentAgent(prompt) {
        return authRequest.post(`/upgpt_agent/document_agent/generate/`, { prompt }, { timeout: 120000 } );
    }
    getUserDocumentAgentMenuList() {
        return authRequest.get(`/upgpt_agent/document_agent/`);
    }
    deleteDocumentAgent(id) {
        return authRequest.delete(`/upgpt_agent/document_agent/${id}/`)
    }
    editDocumentAgent(id, data) {
        return authRequest.put(`/upgpt_agent/document_agent/${id}/`, data)
    }
    getUserDocumentDetail(id) {
        return authRequest.get(`/upgpt_agent/document_agent/${id}/`);
    }
    addDocUserAgentO365Account(id, data) {
        return authRequest.post(`/upgpt_agent/document_agent/${id}/connect_onedrive/`, data);
    }
    getUserAgentSharepointData(id, path = "/") {
        return authRequest.get(`/upgpt_agent/document_agent/${id}/list_onedrive_items/`, { params: { path } });
    }
    documentAgentTableHeader(id) {
        return authRequest.get(`/upgpt_agent/document_agent/table_configuration/${id}/`);
    }
    documentAgentTableData(id, params) {
        return authRequest.get(`/upgpt_agent/document_agent/table_configuration/${id}/data/`, { params });
    }
    // documentAgentTableCell(id, data) {
    //     return authRequest.get(`/upgpt_agent/document_agent/table_configuration/${id}/data/`, data);
    // }
    documentAgentTableUpdateCell(pk, data) {
        return authRequest.patch(`/upgpt_agent/document_agent/table_configuration/data/${pk}/`, data);
    }
    getFlexfieldDataRow(objectId) {
        return authRequest.get(`/upgpt_agent/document_agent/table_configuration/data/${objectId}/`);
    }
    attachFolder(id, data) {
        return authRequest.post(`/upgpt_agent/document_agent/${id}/attach_folder/`, data);
    }
    deleteFile(id, data) {
        return authRequest.post(`/upgpt_agent/document_agent/${id}/detach_folder/`, data);
    }
    runAgent(id, payload = { type: "default" }) {
        return authRequest.post(`/upgpt_agent/document_agent/${id}/run/`, payload);
    }
    checkCurrentStatus(id, params) {
        return authRequest.get(`/upgpt_agent/document_agent/table_configuration/${id}/flexfield_status/`, { params });
    }
    updateCurrentStatus(id) {
        return authRequest.put(`/upgpt_agent/document_agent/${id}/`);
    }
    autoSyncDocumentAgent(id, data) {
        return authRequest.patch(`/upgpt_agent/document_agent/${id}/schedule_update/`, data);
    }
    documentAgentExport(id) {
        return authRequest.post(`/upgpt_agent/document_agent/${id}/export/`);
    }
    editDocumentAgentConfig(id, data) {
        return authRequest.put(`/upgpt_agent/document_agent/${id}/agent_config/`, data)
    }
    saveDocumentAgentAsTemplate(id, data) {
        return authRequest.post(`/upgpt_agent/document_agent/${id}/save_as_template/`, data);
    }
    documentAgentFlexfieldReference(tableConfigId, tableName) {
        return authRequest.get(`/upgpt_agent/document_agent/table_configuration/${tableConfigId}/flexfield_reference/`, { params: { tableName } });
    }
    documentAgentFlexfieldReferenceChunk(rowObjectId, contextId) {
        return authRequest.get(`/upgpt_agent/document_agent/flexfielddata/${rowObjectId}/flexfield_reference/chunk/`, { params: { contextId } });
    }
    documentAgentFlexfieldReferenceByRow(rowObjectId) {
        return authRequest.get(`/upgpt_agent/document_agent/flexfielddata/${rowObjectId}/flexfield_reference/`);
    }
    documentAgentExtractedText(rowObjectId, columnName) {
        return authRequest.get(`/upgpt_agent/document_agent/flexfielddata/${rowObjectId}/extracted_text/`, { params: { column_name: columnName } });
    }
    documentAgentCustomButton(data) {
        return authRequest.post(`/upgpt_agent/document_agent/custom_button/`, data);
    }
    getConsentFormOptions() {
        return this.documentAgentCustomButton({ python_code: "get_consent_form_options", });
    }
    generateConsentForm(payload) {
        return authRequest.post("/upgpt_agent/document_agent/custom_button/", payload, { responseType: "blob", timeout: 0 });
    }
    updateAgentConfigColumn(agentId, payload) {
        return authRequest.put(`/upgpt_agent/document_agent/${agentId}/agent_config/`, payload);
    }
    addAgentConfigColumn(agentId, payload) {
        return authRequest.post(`/upgpt_agent/document_agent/${agentId}/agent_config/`, payload);
    }
    documentAgentSingleSelectLabelUpdate(tableConfigId, payload) {
        return authRequest.post(`/upgpt_agent/document_agent/table_configuration/${tableConfigId}/single_select_label_update/`, payload);
    }
    documentAgentSetDirtyflag(tableConfigId, payload) {
        return authRequest.post(`/upgpt_agent/document_agent/table_configuration/${tableConfigId}/set_dirtyflag/`, payload);
    }
    getDocumentAgentFileType(agentId) {
        return authRequest.get(`/upgpt_agent/document_agent/${agentId}/file_type/`);
    }
    createFlexfieldData(tableConfigId, payload = {}) {
        return authRequest.post(`/upgpt_agent/document_agent/table_configuration/${tableConfigId}/flexfield_data/`, payload);
    }
    uploadDocumentAgentFile(tableConfigId, formData) {
        return authRequest.post(`/upgpt_agent/document_agent/table_configuration/${tableConfigId}/upload_file/`, formData);
    }
    uploadOutputTemplate(agentId, formData) {
        return authRequest.post(`/upgpt_agent/document_agent/${agentId}/output_template/`, formData);
    }
    deleteOutputTemplate(agentId, columnName) {
        return authRequest.delete(`/upgpt_agent/document_agent/${agentId}/output_template/`, { params: { column_name: columnName } });
    }
    getSasUrl(blobUrl) {
        return authRequest.get(`/upgpt_agent/document_agent/get_sas_url/`, { params: { blob_url: blobUrl } });
    }
    getSasUrlInline(blobUrl) {
        return authRequest.get(`/upgpt_agent/document_agent/get_sas_url/`, { params: { blob_url: blobUrl, inline: true } });
    }
    getSasUrlWithContent(blobUrl) {
        return authRequest.get(`/upgpt_agent/document_agent/get_sas_url/`, { params: { blob_url: blobUrl, include_content: true } });
    }
    getOnedriveFile(objectId, columnName) {
        return authRequest.get(`/upgpt_agent/document_agent/get_onedrive_file/`, {
            params: { object_id: objectId, column_name: columnName },
            responseType: 'blob',
        });
    }
    getDocumentUserAgentDetail(id) {
        return authRequest.get(`/upgpt_agent/document_agent/user_agent_detail/${id}/`);
    }
    getDocumentAgentManageDefinition() {
        return authRequest.get(`/upgpt_agent/document_agent/manage_definition/`);
    }
    postDocumentAgentManageDefinition(payload) {
        return authRequest.post(`/upgpt_agent/document_agent/manage_definition/`, payload);
    }
    putDocumentAgentManageDefinition(id, payload) {
        return authRequest.put(`/upgpt_agent/document_agent/manage_definition/${id}/`, payload);
    }
    deleteDocumentAgentManageDefinition(id) {
        return authRequest.delete(`/upgpt_agent/document_agent/manage_definition/${id}/`);
    }
    deleteDocumentAgentTemplate(id) {
        return authRequest.delete(`/upgpt_agent/document_agent/template/${id}/`);
    }
    getDocumentAgentKnowledgeList(params = {}) {
        return authRequest.get(`/upgpt_agent/document_agent/knowledge_list/`, { params });
    }
    // Work Agent 欄位「模型」下拉的唯一選項來源。請透過 services/workAgentModelService
    // 呼叫，不要直接在元件裡用 —— 快取與預設值判定都在那個模組。
    getDocumentAgentModelList() {
        return authRequest.get(`/upgpt_agent/document_agent/models/`);
    }
    validatePythonScript(script, inputs = null) {
        const body = { script };
        if (inputs !== null) body.inputs = inputs;
        return authRequest.post(`/upgpt_agent/document_agent/validate_python_script/`, body);
    }
    deleteDocumentAgentColumn(agentId, payload) {
        return authRequest.delete(`/upgpt_agent/document_agent/${agentId}/agent_config/`, { data: payload });
    }
    bulkDeleteFlexfieldData(payload) {
        return authRequest.delete(`/upgpt_agent/document_agent/flexfielddata/bulkdelete/`, { data: payload });
    }
    // ==================== Work Agent Access Control ====================
    getTemplateAccess(id) {
        return authRequest.get(`/upgpt_agent/document_agent/template/${id}/permissions/`);
    }
    saveTemplateAccess(id, data) {
        return authRequest.post(`/upgpt_agent/document_agent/template/${id}/permissions/`, data);
    }
    getInstanceAccess(id) {
        return authRequest.get(`/upgpt_agent/document_agent/${id}/permissions/`);
    }
    saveInstanceAccess(id, data) {
        return authRequest.post(`/upgpt_agent/document_agent/${id}/permissions/`, data);
    }
}
export default new UpGPTPortalDataServices();
